/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Remove_User_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to remove user from team. {error}" |
*
* @param {Team_Manager_Remove_User_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_user_failed = /** @type {((inputs: Team_Manager_Remove_User_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_User_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la suppression de l’utilisateur de l’équipe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Benutzer konnte nicht aus dem Team entfernt werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile rimuovere l'utente dal team. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить пользователя из команды. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar el usuario del equipo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法将用户从团队中移除。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`チームからユーザーを削除できませんでした。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टीम से उपयोगकर्ता को हटाने में विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao remover o usuário da equipe. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to remove user from team. ${i?.error}`)
});